import { http } from '@monorepo/infra'
import { StorefrontCarouselSlide } from '../models/homepage-carousel-slide'

interface OperationResult<T> {
    kind: 'success' | 'error'
    data?: T
    errorData?: string
}

export const getCarouselSlidesAsync = async (
    channel: string
): Promise<OperationResult<StorefrontCarouselSlide[]>> => {
    try {
        const res = await http.get<StorefrontCarouselSlide[]>({
            url: `/homepage-carousel/storefront/by-channel/${channel.toLowerCase()}`,
        })

        if (res?.status !== 200) {
            return { kind: 'error', errorData: 'Failed to load carousel slides' }
        }

        return { kind: 'success', data: res.data ?? [] }
    } catch (error) {
        return { kind: 'error', errorData: `Error: ${error}` }
    }
}

export const HomepageCarouselHelper = {
    getCarouselSlidesAsync,
}
